


export function InstrucoesExpedicao() {


    return (


        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant) e a secção “Peças Controladas” da estante do C&amp;Q;</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados das obras em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Expedição.</div>
            <hr className="mb-5" />
            <div><span className="font-bold">3.</span> Proceda à seriação da quantidade de peças encomendada e ao respetivo embalamento;</div>

            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span>  Retire medidas e peso das embalagens enviando por intermédio de ocorrência à Administração para
                emissão de guia de transporte/tratamento.</div>
            <hr className="mb-5" />
            <div ><span className="font-bold">5.</span> No ficheiro de “Expedição”, que deve ser sempre atualizado consoante as entradas/saídas da estante,
                introduza a obra no local de expedição</div>
            <hr className="mb-5" />
            <div ><span className="font-bold">6.</span> Acompanhe a encomenda na estante com a respetiva guia impressa.</div>
            <hr className="mb-5" />
            <div ><span className="font-bold">7.</span> No ficheiro “Stock de Clientes” deve incluir a quantidade das restantes peças de sobra (no caso de existirem)
                e a respetiva localização/caixa.</div>
            <hr className="mb-5" />


        </div>
    )


}